import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';

var Config = require('../../../config');

class ModalPhenotype extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.save = this.save.bind(this);
		this.removeFocus = this.removeFocus.bind(this);
		this.getValuesDistribution = this.getValuesDistribution.bind(this);
		this.setResultsDonation = this.setResultsDonation.bind(this);

		this.state = {
		    show: false,
		    lookups:[],
		    donor_id:"",
		    donation_id:"",
		    modal:"",
		    person_id:"",
			disable_save:false,
			screen:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(donor_id, person_id, donation_id, modal, screen = '') {
		this.setState({show: true, donation_id:donation_id,donor_id:donor_id, person_id:person_id, modal:modal, screen: screen});

		var type = "";
		modal === 'phenotypes' ? type = 'PHENOTYPE_LIST' : type = 'antibodies_list'

		//lookups phenotypes
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'lookups?type='+type+'&option=actives&order=true', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error', error, 'error');
              });
	        }
	    }).then(async (response) =>{
			await this.setState({lookups: response});
			if(donor_id !== ''){
				await this.getResults();
			}

			if(screen !== ''){
				await this.setResultsDonation();
			}
			
		})
	}

	getResults(){
		var type = "";
		var url  = "";
		this.state.modal === 'phenotypes' ?	type = "phenotype" : type='antibody'

		if(this.state.donation_id === 0){
			url = 'phenotypes/by_person?person_id='+this.state.person_id+'&type=phenotype';
			//url = 'donors_has_phenotype_antibodies/by_donor?donor_id='+this.state.donor_id+'&type='+type
		}else{
			if(this.state.donation_id !== undefined){
				url = 'phenotypes/by_type?donation_id='+this.state.donation_id+'&type='+type;
			}else{
				url = 'phenotypes/by_sample?samples_id='+
						this.props.match.params.sample_id+'&type='+type;
			}
			
		}

		fetch(Config.default.apiGateway.URL+url, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error', error, 'error');
              });
	        }
	    })
		.then(response =>{
			if(response !== null){
				for(var j =0; j < response.length;j++){
					for(var i=0; i < this.state.lookups.length;i++){

						if(response[j].phenotype !== undefined && response[j].phenotype !== null){
							if(this.state.lookups[i].key === response[j].phenotype){
								if(this.state.modal === 'phenotypes'){
									document.getElementById(this.state.lookups[i].key).value = response[j].result;
								}
							}
						}else{
							if(this.state.lookups[i].key === response[j].phenotype1 || this.state.lookups[i].key === response[j].antibody){
								if(this.state.modal === 'phenotypes'){
									document.getElementById(this.state.lookups[i].key).value = response[j].result;
								}else{
									if(response[j].result === "1")
										document.getElementById(this.state.lookups[i].id).checked = true;
									else
										document.getElementById(this.state.lookups[i].id).checked = false;
								}
							}
						}
						
					}
				}
			}	
		})
	}

	save(){
		var items = [];
		var aux_obj = {};
		var tipo = "";
		for(var i=0; i < this.state.lookups.length;i++){
			aux_obj = {};
			
			if(this.state.donation_id !== undefined){
				if(this.state.modal === 'phenotypes'){
					aux_obj.phenotype1 = this.state.lookups[i].key
					aux_obj.result = document.getElementById(this.state.lookups[i].key).value;
				}else {
					if(document.getElementById(this.state.lookups[i].id).checked){
						aux_obj.result = 1;
						aux_obj.antibody = this.state.lookups[i].key
					}else{
						aux_obj.result = 0;
						aux_obj.antibody = this.state.lookups[i].key
					}
				}
					
				aux_obj.donation_id = this.state.donation_id; //samples_id en resultados muestra
				aux_obj.donor_id=this.state.donor_id;
				if(aux_obj.result !== ""){
					items.push(aux_obj);
				}
			}else{
				if(this.state.modal === 'phenotypes'){
					aux_obj.phenotype1 = this.state.lookups[i].key
					aux_obj.result = document.getElementById(this.state.lookups[i].key).value;
				}else {
					if(document.getElementById(this.state.lookups[i].id).checked){
						aux_obj.result = 1;
						aux_obj.antibody = this.state.lookups[i].key
					}else{
						aux_obj.result = 0;
						aux_obj.antibody = this.state.lookups[i].key
					}
				}
					
				aux_obj.samples_id = parseInt(this.props.match.params.sample_id, 10); //samples_id en resultados muestra
				aux_obj.donor_id=this.state.donor_id;
				if(aux_obj.result !== ""){
					items.push(aux_obj);
				}

				
			}
				
		}

		this.state.modal === 'phenotypes' ?
			tipo = 'fenotipo'
		: tipo = 'anticuerpo'

		if(items.length===0){
			swal('¡Error', 'No hay resultados para ningún '+tipo, 'error');
			return;
		}

		//lookups phenotypes
		var url = "";
		if(this.state.donation_id === 0){
			//url = 'phenotypes/store?donor_id='+this.state.donor_id;
			url = 'phenotypes/store?person_id='+this.state.person_id+'&option=phenotypes';
		}else{
			if(this.state.donation_id !== undefined){
				url = 'phenotypes?donor_id='+this.state.donor_id+'&person_id='+this.state.person_id;	
			}else{
				if(this.state.donor_id !== undefined){
					url = 'phenotypes?donor_id='+this.state.donor_id+'&person_id='+this.state.person_id;
				}else{
					url = 'phenotypes?donor_id='+this.props.state.sample.donor_id+'&person_id='+this.state.person_id;
				}
				
			}
			
		}
		
		this.props.waiting.handleShow('Guardando...');
		this.setState({disable_save: true});
		fetch(Config.default.apiGateway.URL+url, {
			method : 'post',
			body:JSON.stringify(items),
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error', error, 'error');
              });
	        }
	    })
		.then(response =>{
			this.setState({ show: false, disable_save: false});

			/*
			if(this.state.donation_id === 0){
				this.getResults();
			}else{*/
				this.state.modal === 'phenotypes' ?	
					this.state.donation_id !== undefined ?
						this.props.getFenotipoDonacion(this.state.donation_id, 'fenotipo_donacion')
					: this.props.getFenotipoDonacion(this.props.match.params.sample_id, 'fenotipo_muestra')
				: this.state.donation_id !== undefined ?
					this.props.getFenotipoDonacion(this.state.donation_id, 'antibody_donacion')
				: this.props.getFenotipoDonacion(this.props.match.params.sample_id, 'antibody_muestra')
			//}
			
		})
	}

  	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined){
      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){	
  					if(form.elements[index + 1].getAttribute("disabled") === null){	
    					if(form.elements[index + 1].getAttribute("type") === 'checkbox'){
							form.elements[index + 1].focus();
							form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
    					
    					}else{
    						form.elements[index + 1].focus();
    					}
    					
  					}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 2].focus();
    				}
      				
      			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}

		if(e.key === '+' || e.key === '-'){
		}else{
			e.preventDefault();
		}
  	}

  	removeFocus(e){
  		e.target.removeAttribute("style");
	}
	  
	getValuesDistribution(){
		var items = [];
		var aux_obj = {};
		var tipo = "";
		this.state.lookups.forEach((lookup, i)=>{
			if(this.state.modal === 'phenotypes'){
				aux_obj = {
					phenotype_code: this.state.lookups[i].key,
                	result: document.getElementById(this.state.lookups[i].key).value
				};
				
			}else{
				aux_obj = {result:0};
				if(document.getElementById(this.state.lookups[i].id).checked){
					aux_obj.result = 1;
					aux_obj.antibody_code = this.state.lookups[i].key
				}else{
					aux_obj.result = 0;
					aux_obj.antibody_code = this.state.lookups[i].key
				}
			}

			if(aux_obj.result !== 0 && aux_obj.result !== ""){
				this.props.setValuesDistribution(aux_obj);
			}
						
		});

		this.handleClose();
		
		
	}

	setResultsDonation(){
		var results = this.props.results;

		if(results.length > 0){
			results.map((res)=>{
				var index = -1;

				if(this.state.modal === 'phenotypes'){
					index = this.state.lookups.findIndex(obj => obj.key === res.phenotype_code);
					
					if(index !== -1){
						document.getElementById(this.state.lookups[index].key).value = res.result;
					}
				}else{
					index = this.state.lookups.findIndex(obj => obj.key === res.antibody_code);

					if(index !== -1){
						if(parseInt(res.result) === 1){
							document.getElementById(this.state.lookups[index].id).checked = true;
						}
					}
				}
			})
			
		}
	}

	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.modal === 'phenotypes'? t('content.modal_phenotype.phenotypes') : t('content.modal_phenotype.antibodies')} </Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{maxHeight: "400px",overflowY: "scroll",padding:"10px"}}>
		        	<form>
		        	{/*LIST*/}
					{
					    this.state.lookups.map((item, index) =>{  
			            	return( 	
			            		<div key={index} className="col-xs-12 col-sm-offset-3 col-sm-8 form-group" >
		            				<div className={this.state.modal === 'phenotypes'? "col-xs-12 col-sm-3": "col-xs-12 col-sm-4"}  style={{padding:'0px'}}>
				        				<span>{item.name}:</span>
				        			</div>
				        			<div className={this.state.modal === 'phenotypes'? "col-xs-12 col-sm-3": "col-xs-12 col-sm-8"} style={{padding:"0px"}}>
				        				{this.state.modal === 'phenotypes' ?
				        					<input maxLength="1" style={{fontSize:"16px"}} ref={item.name} onKeyPress={(e) => this.validateInput(e, item.name)}
					        				 type="text" className="form-control" name={item.name} 
					        				 id={item.key} value={item.result}
					        				/>
				        				: <input type="checkbox" key={item.id} id={item.id} name={item.id} onKeyPress={(e) => this.validateInput(e, item.name)} onBlur={this.removeFocus}  />}
					        				
				        			</div>
		            			</div>
				        	)
				        })
					 }
					 </form>
					 </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} 
		        		onClick={()=>this.state.screen === "" ? this.save() : this.getValuesDistribution()} disabled={this.state.disable_save} />
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalPhenotype);